import { env } from './EnvironmentConfig'

export const API_BASE_URL = env.API_ENDPOINT_URL;

const appConfig = {
    apiPrefix: '/adm',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/',
    tourPath: '/',
    locale: 'ko',
    enableMock: true,
}

export default appConfig
